var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-result"},[_vm._t("default",function(){return [_c('p',[_vm._v(_vm._s(_vm.$t("We can't find products matching the selection.")))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }